export enum AuthMessages {
  ERROR = 'Usuario y/o contraseña incorrecta.',
  ERROR_SERVICE = 'Error al iniciar sesión, contacte al equipo de soporte',
  ERROR_LOGOUT = 'Error al cerrar sesión, contacte al equipo de soporte',
  SUCCESS = 'Inicio de sesión satisfactorio.',
}
export enum EmailMessage {
  ERROR = 'Correo electrónico no válido',
  SUCCESS = 'Correo electrónico válido',
}
export enum GenericMessage {
  ERROR = 'Error en la aplicación',
  SUCCESS = 'Cambio satisfactorio'
}
export enum VerificationMessages {
  BLOCK = '¿Estás seguro de bloquear a <nombre>?',
  UNBLOCK = '¿Estás seguro de desbloquear a <nombre>?',
  VERIFY = 'Verifica que el nombre de la cuenta sea el mismo que el de la identificación oficial. ¿El nombre es correcto?',
}
export enum OptionsMessages {
  SI = 'Sí',
  NO = 'No',
  ACEPTAR = 'Aceptar',
  CANCELAR = 'Cancelar',
}
export enum PlaceholderMessageSearch {
  ALL = 'Buscar',
  ID = 'Buscar por ID',
  NAME = 'Buscar por nombre',
  EMAIL = 'Buscar por correo electrónico',
  PHONE = 'Buscar por número telefónico',
}
export enum ErrorMessagesToast {
  ERROR = '¡Ups! Ocurrió un error, contacta al equipo de soporte',
}
